(function () {
  "use strict";

  let productCardGridInitialized = false;

  function regenerateUniqueIds() {
    let globalCounter = 0;
    const allProductCards = document.querySelectorAll(
      ".product-card[data-unique-card-id]"
    );

    allProductCards.forEach((card) => {
      globalCounter++;
      const productId = card.getAttribute("data-product-id");
      const newUniqueId = `card-${productId}-${globalCounter}-${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;

      card.setAttribute("data-unique-card-id", newUniqueId);

      const colorButtons = card.querySelectorAll(".color-option[onclick]");
      colorButtons.forEach((button) => {
        const currentOnclick = button.getAttribute("onclick");
        const updatedOnclick = currentOnclick.replace(
          /switchVariant\(this,\s*'([^']*)',\s*'([^']*)'\)/,
          `switchVariant(this, '$1', '${newUniqueId}')`
        );
        button.setAttribute("onclick", updatedOnclick);
      });
    });
  }

  function initializeProductCardGrid() {
    if (productCardGridInitialized) return;
    productCardGridInitialized = true;

    regenerateUniqueIds();
    updateNewBadgesGeneric();

    if (typeof window.initializeAllMiles === "undefined") {
      initializeGenericMiles();
    }
  }

  function calculateGenericMiles(productCard, variantId = null) {
    const productData = JSON.parse(productCard.dataset.productJson);
    const isPrimpassCustomer =
      productCard.dataset.isPrimepassCustomer === "true";
    const discountMetafieldPrice = productCard.dataset.discountMetafieldPrice;
    const additionalMilesData = productCard.dataset.additionalMiles;

    const currentVariantId =
      variantId || productCard.querySelector(".btn-cart")?.dataset.variantId;

    let productPrice = productData.price;

    if (currentVariantId) {
      const productVariant = productData.variants.find(
        (variant) => variant.id == currentVariantId
      );
      if (productVariant) {
        productPrice = productVariant.price;
      }
    }

    if (discountMetafieldPrice && discountMetafieldPrice !== "null") {
      productPrice = parseFloat(discountMetafieldPrice) * 100;
    }

    productPrice = productPrice / 100;

    let baseMiles, multiplier;

    if (isPrimpassCustomer) {
      baseMiles = Math.floor(productPrice * 2);
      multiplier = 2;
    } else {
      baseMiles = Math.floor(productPrice);
      multiplier = 1;
    }

    let additionalMiles = 0;
    if (additionalMilesData && currentVariantId) {
      const additionalMilesArray = additionalMilesData.split("|");
      const additionalMilesEntry = additionalMilesArray.find(
        (entry) => entry.split(":")[0] === currentVariantId
      );
      if (additionalMilesEntry) {
        additionalMiles = parseInt(additionalMilesEntry.split(":")[1]) || 0;
      }
    }

    const totalMiles = baseMiles + additionalMiles;

    return {
      baseMiles: baseMiles,
      additionalMiles: additionalMiles,
      totalMiles: totalMiles,
      isPrimpassCustomer: isPrimpassCustomer,
      multiplier: multiplier,
    };
  }

  function calculateCouponValueGeneric(miles) {
    const conversionTable = [
      { miles: 500000, yen: 50000 },
      { miles: 300000, yen: 24000 },
      { miles: 100000, yen: 6000 },
      { miles: 50000, yen: 2500 },
      { miles: 30000, yen: 900 },
      { miles: 10000, yen: 100 },
    ];

    let remainingMiles = Number(miles);
    let totalYen = 0;

    for (let i = 0; i < conversionTable.length; i++) {
      while (remainingMiles >= conversionTable[i].miles) {
        totalYen += conversionTable[i].yen;
        remainingMiles -= conversionTable[i].miles;
      }
    }

    return totalYen;
  }

  function updateGenericMilesDisplay(productCard, variantId = null) {
    const milesElement = productCard.querySelector("[data-miles-amount]");
    if (!milesElement) return;

    const milesData = calculateGenericMiles(productCard, variantId);

    if (!milesData || milesData.totalMiles === 0) {
      milesElement.className = "miles-amount loading-dots";
      milesElement.textContent = "";
      return;
    }

    milesElement.className = "miles-amount";

    const couponValue = calculateCouponValueGeneric(milesData.totalMiles);
    const displayCouponValue = 1000;

    let output = "";

    if (couponValue >= displayCouponValue) {
      output = `約¥${couponValue.toLocaleString()}相当`;
    } else {
      if (milesData.additionalMiles > 0) {
        output = `${milesData.baseMiles.toLocaleString()}+${milesData.additionalMiles.toLocaleString()}マイル`;
      } else {
        output = `${milesData.totalMiles.toLocaleString()}マイル`;
      }
    }

    milesElement.textContent = output;
  }

  function initializeGenericMiles() {
    const productCards = document.querySelectorAll(
      ".product-card[data-product-json]"
    );

    productCards.forEach((productCard, index) => {
      const milesElement = productCard.querySelector("[data-miles-amount]");
      if (milesElement) {
        milesElement.className = "miles-amount loading-dots";
        milesElement.textContent = "";
      }

      setTimeout(() => {
        updateGenericMilesDisplay(productCard);
      }, 100 + index * 50);
    });
  }

  function isWithinTwoMonthsGeneric(publishedDateString) {
    if (!publishedDateString || publishedDateString === "") return false;

    const now = new Date();
    const japanTime = new Date(
      now.getTime() + 9 * 60 * 60 * 1000 - now.getTimezoneOffset() * 60 * 1000
    );

    const publishedDate = new Date(publishedDateString + "T00:00:00+09:00");

    const twoMonthsAgo = new Date(japanTime);
    twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);

    return publishedDate >= twoMonthsAgo;
  }

  function updateNewBadgesGeneric() {
    const newBadges = document.querySelectorAll(
      ".product-badge-new[data-published-at]"
    );

    newBadges.forEach((badge) => {
      const publishedAt = badge.dataset.publishedAt;

      if (isWithinTwoMonthsGeneric(publishedAt)) {
        badge.style.display = "block";
        badge.classList.add("product-badge");
      } else {
        badge.style.display = "none";
      }
    });
  }

  function switchVariantGeneric(colorButton, productId, uniqueCardId = null) {
    let productCard = null;

    if (uniqueCardId) {
      productCard = document.querySelector(
        `[data-unique-card-id="${uniqueCardId}"]`
      );
    }

    if (!productCard) {
      productCard = colorButton.closest("[data-product-id]");
    }

    if (
      !productCard ||
      productCard.getAttribute("data-product-id") !== productId.toString()
    ) {
      return;
    }

    const mainImage = productCard.querySelector(".main-product-image");
    const newImageSrc = colorButton.dataset.imageSrc;
    const newVariantId = colorButton.dataset.variantId;

    if (mainImage && newImageSrc) {
      mainImage.src = newImageSrc;
      mainImage.dataset.variantId = newVariantId;
    }

    const cartButton = productCard.querySelector(".btn-cart");
    if (cartButton) {
      cartButton.dataset.variantId = newVariantId;
    }

    updateAmazonLinkGeneric(productCard, newVariantId);

    const milesElement = productCard.querySelector("[data-miles-amount]");
    if (milesElement) {
      milesElement.className = "miles-amount loading-dots";
      milesElement.textContent = "";
    }

    setTimeout(() => {
      updateGenericMilesDisplay(productCard, newVariantId);
    }, 200);

    const allColorOptions = productCard.querySelectorAll(".color-option");
    allColorOptions.forEach((option) => {
      option.classList.remove("active");
    });
    colorButton.classList.add("active");
  }

  function updateAmazonLinkGeneric(productCard, variantId) {
    const amazonButton = productCard.querySelector(".amazon-link");
    if (!amazonButton) return;

    const variantAmazonData = amazonButton.dataset.variantAmazon;
    if (!variantAmazonData) return;

    const variantDataPairs = variantAmazonData.split("|");
    let newAmazonLink = null;

    for (const pair of variantDataPairs) {
      const [id, link] = pair.split(":");
      if (id == variantId && link && link !== "null" && link !== "") {
        newAmazonLink = link;
        break;
      }
    }

    if (newAmazonLink) {
      const currentHref = amazonButton.href;
      const tagMatch = currentHref.match(/[?&]tag=([^&]*)/);
      const tagParam = tagMatch ? `&tag=${tagMatch[1]}` : "";
      const newHref = `https://www.amazon.co.jp/dp/${newAmazonLink}?&_encoding=UTF8${tagParam}`;

      amazonButton.href = newHref;
      amazonButton.classList.remove("btn-amazon-inactive");
      amazonButton.style.pointerEvents = "";
    } else {
      amazonButton.removeAttribute("href");
      amazonButton.classList.add("btn-amazon-inactive");
      amazonButton.style.pointerEvents = "none";
    }
  }

  if (typeof window.switchVariant === "undefined") {
    window.switchVariant = switchVariantGeneric;
  } else {
    window.switchVariantGeneric = switchVariantGeneric;
  }

  if (typeof window.updateAmazonLinkGeneric === "undefined") {
    window.updateAmazonLinkGeneric = updateAmazonLinkGeneric;
  }

  if (typeof window.updateGenericMilesDisplay === "undefined") {
    window.updateGenericMilesDisplay = updateGenericMilesDisplay;
  }

  if (typeof window.initializeProductCardGrid === "undefined") {
    window.initializeProductCardGrid = initializeProductCardGrid;
  }

  async function addToCartWithPresents(button) {
    const mainVariantId = button.dataset.variantId;
    const presentProductsData = button.dataset.presentProducts;
    const isPreview = button.dataset.preview === "true";
    const productId = button.dataset.productId;
    const productTags = button.dataset.productTags ? button.dataset.productTags.split(",") : [];

    const originalText = button.innerHTML;
    button.innerHTML = "<span>追加中...</span>";
    button.disabled = true;
    button.style.opacity = "0.7";

    // single_purchaseタグのチェック（タグをトリムして比較）
    const isSinglePurchaseProduct = productTags.some(tag => tag.trim() === "single_purchase");

    // カートの内容をチェック
    try {
      const cartResponse = await fetch("/cart.js");
      if (!cartResponse.ok) {
        throw new Error("カート情報の取得に失敗しました");
      }
      const cart = await cartResponse.json();

      // カート内の商品をチェック
      let hasSinglePurchaseInCart = false;
      let hasRegularProductInCart = false;
      let cartSinglePurchaseProductId = null;

      // カート内の商品情報を並列で取得
      const productPromises = cart.items.map(async (item) => {
        try {
          const productResponse = await fetch(`/products/${item.handle}.js`);
          if (productResponse.ok) {
            const product = await productResponse.json();
            return { product, item };
          }
        } catch (error) {
          console.warn("商品情報の取得に失敗しました:", item.handle);
        }
        return null;
      });

      const productResults = await Promise.all(productPromises);

      for (const result of productResults) {
        if (!result) continue;
        
        const { product, item } = result;
        // タグ情報の処理（配列または文字列の両方に対応）
        let itemTags = [];
        if (Array.isArray(product.tags)) {
          itemTags = product.tags;
        } else if (typeof product.tags === "string") {
          itemTags = product.tags.split(",").map(tag => tag.trim());
        }
        
        if (itemTags.includes("single_purchase")) {
          hasSinglePurchaseInCart = true;
          cartSinglePurchaseProductId = product.id;
        } else {
          hasRegularProductInCart = true;
        }
      }

      // 制約チェック
      if (isSinglePurchaseProduct) {
        // single_purchase商品を追加しようとしている場合
        if (hasSinglePurchaseInCart) {
          // カートに既にsingle_purchase商品がある場合
          if (productId && cartSinglePurchaseProductId && productId.toString() !== cartSinglePurchaseProductId.toString()) {
            // 異なるsingle_purchase商品を追加しようとしている
            button.innerHTML = originalText;
            button.disabled = false;
            button.style.opacity = "1";
            if (typeof window.showNotification === "function") {
              window.showNotification("本製品は他の製品と同時購入はできません。カート内の他の商品を削除してから再度お試しください。", "error");
            } else {
              alert("本製品は他の製品と同時購入はできません。カート内の他の商品を削除してから再度お試しください。");
            }
            return;
          }
          // 同じ商品の場合は追加可能（数量増加）
        } else if (hasRegularProductInCart) {
          // カートに通常商品がある場合
          button.innerHTML = originalText;
          button.disabled = false;
          button.style.opacity = "1";
          alert("本製品は他の製品と同時購入はできません。カート内の他の商品を削除してから再度お試しください。");
          return;
        }
      } else {
        // 通常商品を追加しようとしている場合
        if (hasSinglePurchaseInCart) {
          // カートにsingle_purchase商品がある場合
          button.innerHTML = originalText;
          button.disabled = false;
          button.style.opacity = "1";
          if (typeof window.showNotification === "function") {
            window.showNotification("カート内の商品は他の製品と同時購入はできません。カート内の商品を削除してから再度お試しください。", "error");
          } else {
            alert("カート内の商品は他の製品と同時購入はできません。カート内の商品を削除してから再度お試しください。");
          }
          return;
        }
      }
    } catch (error) {
      console.error("カートチェックエラー:", error);
      // エラーが発生した場合は警告を出して続行
    }

    const itemsToAdd = [];

    if (mainVariantId) {
      itemsToAdd.push({
        id: parseInt(mainVariantId),
        quantity: 1,
      });
    }

    if (
      !isPreview &&
      presentProductsData &&
      presentProductsData.trim() !== ""
    ) {
      const presentVariantIds = presentProductsData.split("|");
      presentVariantIds.forEach((variantId) => {
        if (variantId && variantId.trim() !== "") {
          itemsToAdd.push({
            id: parseInt(variantId.trim()),
            quantity: 1,
          });
        }
      });
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: itemsToAdd,
        }),
      });

      if (!response.ok) {
        throw new Error(`カートへの追加に失敗しました: ${response.status}`);
      }

      const result = await response.json();

      button.innerHTML = "<span>✓ 追加完了</span>";
      button.style.backgroundColor = "#28a745";

      // 高度なポップアップ機能を優先的に使用
      if (typeof window.showShopifyCartNotification === "function") {
        window.showShopifyCartNotification({
          variant_id: parseInt(mainVariantId),
          quantity: 1,
          product_id: result.items ? result.items[0]?.product_id : null,
          has_present_products: itemsToAdd.length > 1,
          total_items_added: itemsToAdd.length,
          present_products_count: itemsToAdd.length - 1,
        });
      } else {
        // フォールバック：カスタムポップアップを表示
        showEnhancedCartPopup({
          variant_id: parseInt(mainVariantId),
          quantity: 1,
          product_id: result.items ? result.items[0]?.product_id : null,
          has_present_products: itemsToAdd.length > 1,
          total_items_added: itemsToAdd.length,
          present_products_count: itemsToAdd.length - 1,
        });
      }

      if (typeof window.updateCartCount === "function") {
        window.updateCartCount();
      }

      if (typeof window.updateCartDrawer === "function") {
        window.updateCartDrawer();
      }

      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
        button.style.opacity = "1";
        button.style.backgroundColor = "";
      }, 1000);
    } catch (error) {
      showCartAddErrorMessage(error.message);

      button.innerHTML = originalText;
      button.disabled = false;
      button.style.opacity = "1";
      button.style.backgroundColor = "";
    }
  }

  function showCartAddSuccessMessage(itemCount) {
    if (typeof window.showNotification === "function") {
      const message =
        itemCount > 1
          ? `${itemCount}つの製品をカートに追加しました（プレゼント製品を含む）`
          : "製品をカートに追加しました";
      window.showNotification(message, "success");
      return;
    }

    let mainMessage = "✓ カートに追加しました";
    let subMessage = "";

    if (itemCount > 1) {
      const presentCount = itemCount - 1;
      subMessage = `<div style="font-size: 12px; margin-top: 4px; opacity: 0.9;">プレゼント製品 ${presentCount}個も追加されました</div>`;
    }

    const messageDiv = document.createElement("div");
    messageDiv.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #28a745;
        color: white;
        padding: 16px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        max-width: 300px;
        font-family: 'Noto Sans JP', sans-serif;
        font-size: 14px;
        z-index: 10000;
      `;

    messageDiv.innerHTML = `
        <div style="display: flex; justify-content: space-between; align-items: flex-start;">
          <div>
            <span>${mainMessage}</span>
            ${subMessage}
          </div>
          <a href="/cart" style="color: white; text-decoration: underline; margin-left: 10px; flex-shrink: 0;">カートを見る</a>
        </div>
      `;

    document.body.appendChild(messageDiv);

    setTimeout(() => {
      if (messageDiv.parentNode) {
        messageDiv.parentNode.removeChild(messageDiv);
      }
    }, 3000);
  }

  function showCartAddErrorMessage(errorMessage) {
    if (typeof window.showNotification === "function") {
      window.showNotification("カートへの追加に失敗しました", "error");
      return;
    }

    alert("カートへの追加に失敗しました。もう一度お試しください。");
  }

  // 拡張カートポップアップ機能（page-primeday2025.liquidの機能を参考）
  function showEnhancedCartPopup(cartData) {
    // まずShopifyの標準ポップアップを試す
    const cartPopupWrapper = document.querySelector(
      "[data-cart-popup-wrapper]"
    );
    const cartPopup = document.querySelector("[data-cart-popup]");

    if (cartPopupWrapper && cartPopup) {
      showShopifyStyleCartPopup(cartData, cartPopupWrapper, cartPopup);
    } else {
      // フォールバック：カスタムポップアップを表示
      showCustomCartPopup(cartData);
    }
  }

  function showShopifyStyleCartPopup(cartData, cartPopupWrapper, cartPopup) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const addedItem = cart.items.find(
          (item) =>
            item.variant_id === cartData.variant_id ||
            item.id === cartData.variant_id
        );

        if (!addedItem) {
          console.error("Added item not found in cart");
          showCustomCartPopup(cartData);
          return;
        }

        // 商品情報を設定
        const titleElement = document.querySelector("[data-cart-popup-title]");
        if (titleElement) titleElement.textContent = addedItem.product_title;

        const imageWrapper = document.querySelector(
          "[data-cart-popup-image-wrapper]"
        );
        if (imageWrapper && addedItem.featured_image) {
          imageWrapper.innerHTML = `
            <img 
              src="${addedItem.featured_image.url}" 
              alt="${addedItem.featured_image.alt || addedItem.product_title}"
              class="cart-popup-item__image"
              width="70"
              height="70"
            >
          `;
          imageWrapper.classList.remove("hide");
        }

        const quantityElement = document.querySelector(
          "[data-cart-popup-quantity]"
        );
        if (quantityElement)
          quantityElement.textContent = cartData.quantity || 1;

        const cartQuantityElements = document.querySelectorAll(
          "[data-cart-popup-cart-quantity]"
        );
        cartQuantityElements.forEach((element) => {
          element.textContent = cart.item_count;
        });

        // 商品詳細を設定
        const productDetails = document.querySelector(
          "[data-cart-popup-product-details]"
        );
        if (productDetails) {
          let detailsHTML = "";

          if (
            addedItem.variant_title &&
            addedItem.variant_title !== "Default Title"
          ) {
            detailsHTML += `<li>${addedItem.variant_title}</li>`;
          }

          if (addedItem.properties) {
            Object.entries(addedItem.properties).forEach(([key, value]) => {
              if (value && key.charAt(0) !== "_") {
                detailsHTML += `<li>${key}: ${value}</li>`;
              }
            });
          }

          // プレゼント製品の情報を表示
          if (
            cartData.has_present_products &&
            cartData.present_products_count > 0
          ) {
            detailsHTML += `<li style="color: #28a745; font-weight: bold; margin-top: 8px;">
              ✓ プレゼント製品 ${cartData.present_products_count}個も追加されました
            </li>`;
          }

          productDetails.innerHTML = detailsHTML;
        }

        // ポップアップを表示
        cartPopupWrapper.classList.remove("cart-popup-wrapper--hidden");
        cartPopupWrapper.classList.remove("critical-hidden");
        cartPopup.focus();

        if (!cartPopupWrapper.hasAttribute("data-events-attached")) {
          setupEnhancedCartPopupEvents();
          cartPopupWrapper.setAttribute("data-events-attached", "true");
        }
      })
      .catch((error) => {
        console.error("Failed to fetch cart data:", error);
        showCustomCartPopup(cartData);
      });
  }

  function setupEnhancedCartPopupEvents() {
    const cartPopupWrapper = document.querySelector(
      "[data-cart-popup-wrapper]"
    );
    const closeButton = document.querySelector("[data-cart-popup-close]");
    const dismissButton = document.querySelector("[data-cart-popup-dismiss]");

    if (closeButton)
      closeButton.addEventListener("click", hideEnhancedCartPopup);
    if (dismissButton)
      dismissButton.addEventListener("click", hideEnhancedCartPopup);

    if (cartPopupWrapper) {
      cartPopupWrapper.addEventListener("click", function (e) {
        if (e.target === cartPopupWrapper) hideEnhancedCartPopup();
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") hideEnhancedCartPopup();
    });
  }

  function hideEnhancedCartPopup() {
    const cartPopupWrapper = document.querySelector(
      "[data-cart-popup-wrapper]"
    );
    if (cartPopupWrapper) {
      cartPopupWrapper.classList.add("cart-popup-wrapper--hidden");
      cartPopupWrapper.classList.add("critical-hidden");
    }
  }

  function showCustomCartPopup(cartData) {
    // 既存のカスタムポップアップを削除
    const existingPopup = document.querySelector(".enhanced-cart-popup");
    if (existingPopup) {
      existingPopup.remove();
    }

    // カスタムポップアップのHTML作成
    const popupHTML = `
      <div class="enhanced-cart-popup-overlay" style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: fadeIn 0.3s ease;
      ">
        <div class="enhanced-cart-popup" style="
          background: white;
          border-radius: 12px;
          padding: 24px;
          max-width: 400px;
          width: 90%;
          max-height: 80vh;
          overflow-y: auto;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
          position: relative;
          animation: slideUp 0.3s ease;
        ">
          <button class="enhanced-cart-popup-close" style="
            position: absolute;
            top: 16px;
            right: 16px;
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #666;
            padding: 0;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
          ">×</button>
          
          <div class="enhanced-cart-popup-content">
            <div class="success-icon" style="
              text-align: center;
              margin-bottom: 16px;
            ">
              <div style="
                width: 60px;
                height: 60px;
                background: #28a745;
                border-radius: 50%;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-size: 24px;
                font-weight: bold;
              ">✓</div>
            </div>
            
            <h3 style="
              text-align: center;
              margin: 0 0 16px 0;
              font-size: 18px;
              font-weight: bold;
              color: #333;
            ">カートに追加しました！</h3>
            
            <div class="cart-popup-product-info" style="
              border: 1px solid #e0e0e0;
              border-radius: 8px;
              padding: 16px;
              margin-bottom: 16px;
            ">
              <div class="product-details-loading" style="
                text-align: center;
                color: #666;
                padding: 20px;
              ">製品情報を読み込み中...</div>
            </div>
            
            ${
              cartData.has_present_products &&
              cartData.present_products_count > 0
                ? `
              <div class="present-info" style="
                background: #f0f8ff;
                border: 1px solid #28a745;
                border-radius: 8px;
                padding: 12px;
                margin-bottom: 16px;
                text-align: center;
              ">
                <div style="color: #28a745; font-weight: bold; margin-bottom: 4px;">
                  🎁 プレゼント製品も追加されました！
                </div>
                <div style="color: #666; font-size: 14px;">
                  プレゼント製品 ${cartData.present_products_count}個も一緒にカートに追加されました
                </div>
              </div>
            `
                : ""
            }
            
            <div class="cart-popup-actions" style="
              display: flex;
              gap: 12px;
              margin-top: 20px;
            ">
              <button class="continue-shopping-btn" style="
                flex: 1;
                padding: 12px 16px;
                background: #f5f5f5;
                border: 1px solid #ddd;
                border-radius: 6px;
                cursor: pointer;
                font-size: 14px;
                color: #333;
              ">買い物を続ける</button>
              
              <a href="/cart" style="
                flex: 1;
                padding: 12px 16px;
                background: #007bff;
                color: white;
                text-decoration: none;
                text-align: center;
                border-radius: 6px;
                font-size: 14px;
                font-weight: bold;
              ">カートを見る</a>
            </div>
          </div>
        </div>
      </div>
    `;

    // スタイルを追加
    const style = document.createElement("style");
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      
      @keyframes slideUp {
        from { transform: translateY(30px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      
      .enhanced-cart-popup-close:hover {
        background: #f0f0f0 !important;
        border-radius: 50% !important;
      }
      
      .continue-shopping-btn:hover {
        background: #e0e0e0 !important;
      }
    `;
    document.head.appendChild(style);

    // ポップアップをDOMに追加
    document.body.insertAdjacentHTML("beforeend", popupHTML);

    // 製品情報を非同期で取得・表示
    loadProductInfoForPopup(cartData);

    // イベントリスナーを設定
    setupCustomCartPopupEvents();
  }

  function loadProductInfoForPopup(cartData) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const addedItem = cart.items.find(
          (item) =>
            item.variant_id === cartData.variant_id ||
            item.id === cartData.variant_id
        );

        if (addedItem) {
          const productInfoContainer = document.querySelector(
            ".product-details-loading"
          );
          if (productInfoContainer) {
            productInfoContainer.innerHTML = `
              <div style="display: flex; align-items: center; gap: 12px;">
                ${
                  addedItem.featured_image
                    ? `
                  <img src="${addedItem.featured_image.url}" alt="${addedItem.product_title}" 
                       style="width: 60px; height: 60px; object-fit: cover; border-radius: 6px;">
                `
                    : ""
                }
                <div style="flex: 1; text-align: left;">
                  <div style="font-weight: bold; margin-bottom: 4px; color: #333;">
                    ${addedItem.product_title}
                  </div>
                  ${
                    addedItem.variant_title &&
                    addedItem.variant_title !== "Default Title"
                      ? `
                    <div style="font-size: 14px; color: #666; margin-bottom: 4px;">
                      ${addedItem.variant_title}
                    </div>
                  `
                      : ""
                  }
                  <div style="font-size: 14px; color: #666;">
                    数量: ${cartData.quantity || 1}
                  </div>
                </div>
              </div>
            `;
          }
        }
      })
      .catch((error) => {
        console.error("Failed to load product info:", error);
        const productInfoContainer = document.querySelector(
          ".product-details-loading"
        );
        if (productInfoContainer) {
          productInfoContainer.innerHTML =
            '<div style="color: #999;">製品情報の読み込みに失敗しました</div>';
        }
      });
  }

  function setupCustomCartPopupEvents() {
    const overlay = document.querySelector(".enhanced-cart-popup-overlay");
    const closeBtn = document.querySelector(".enhanced-cart-popup-close");
    const continueBtn = document.querySelector(".continue-shopping-btn");

    const closePopup = () => {
      if (overlay) {
        overlay.style.animation = "fadeOut 0.3s ease";
        setTimeout(() => overlay.remove(), 300);
      }
    };

    if (closeBtn) closeBtn.addEventListener("click", closePopup);
    if (continueBtn) continueBtn.addEventListener("click", closePopup);
    if (overlay) {
      overlay.addEventListener("click", (e) => {
        if (e.target === overlay) closePopup();
      });
    }

    // Escapeキーで閉じる
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        closePopup();
        document.removeEventListener("keydown", handleEscape);
      }
    };
    document.addEventListener("keydown", handleEscape);

    // フェードアウトアニメーションのスタイルを追加
    const fadeOutStyle = document.createElement("style");
    fadeOutStyle.textContent = `
      @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
      }
    `;
    document.head.appendChild(fadeOutStyle);
  }

  if (typeof window.addToCartWithPresents === "undefined") {
    window.addToCartWithPresents = addToCartWithPresents;
  }

  if (typeof window.showEnhancedCartPopup === "undefined") {
    window.showEnhancedCartPopup = showEnhancedCartPopup;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeProductCardGrid);
  } else {
    initializeProductCardGrid();
  }
})();
